import { BACKEND_URL, ENDPOINTS } from 'controller/constants';
import { getData } from 'controller/dataUtils';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from "react-router-dom";

const FooterComponent = () => {
    const location = useLocation();
    const [partners, setPartners] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { access_token } = useSelector(state => state.auth);

    useEffect(() => {
        if (!access_token) {
            setLoading(false);
            return;
        }

        const fetchPartners = async () => {
            try {
                const result = await getData(ENDPOINTS.PARTNERS_BRANDING, {}, access_token);
                const partnersData = result?.data;

                if (partnersData) {
                    setPartners(partnersData);
                } else {
                    setError('No partners data found.');
                }
            } catch (error) {
                console.error('Erro ao buscar Partners:', error);
                setError(error.response?.data?.message || 'Erro ao buscar Partners');
            } finally {
                setLoading(false);
            }
        };

        fetchPartners();
    }, [access_token]);

    // Check for loading or error states
    if (loading) {
        return <footer id="main-footer"><div className="container">Carregando...</div></footer>;
    }

    if (error) {
        return (
            <footer id="main-footer">
                <div className="container">
                    <div className="error-message">Erro: {error}</div>
                </div>
            </footer>
        );
    }

    return (
        <footer id="main-footer" location={location.pathname}>
            <div className="container">
                {partners.length > 0 ? (
                    partners
                        .filter((partner) => partner.name.toLowerCase() !== "igniteers") // Ignore "igniteers"
                        .map((partner) => {
                            const logoPath = partner.logo && partner.logo.includes("/media/logos/")
                                ? partner.logo
                                : partner.logo
                                    ? `/media/logos/${partner.logo.replace("/media/", "")}`
                                    : '/media/logos/default-logo.png'; // Use a default logo if partner.logo is null

                            return (
                                <div className="main-footer--partner-item" key={partner.identifier}>
                                    <img
                                        src={`${BACKEND_URL}/partners/${partner.identifier}/logo/`}
                                        alt={`Logo de ${partner.name}`}
                                        className="partner-logo"
                                    />
                                </div>
                            );
                        })
                ) : (
                    <div className="main-footer--no-partners">Sem parceiros disponíveis.</div>
                )}
            </div>
        </footer>
    );
};

export default FooterComponent;
